import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface OrgState {
  selectedOrgId: string | null;
}

// Load initial state from localStorage if available
const savedOrgId = localStorage.getItem('selectedOrgId');

const initialState: OrgState = {
  selectedOrgId: savedOrgId || null,
};

export const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    setSelectedOrgId: (state, action: PayloadAction<string | null>) => {
      state.selectedOrgId = action.payload;
      if (action.payload) {
        localStorage.setItem('selectedOrgId', action.payload);
      } else {
        localStorage.removeItem('selectedOrgId');
      }
    },
  },
});

export const { setSelectedOrgId } = orgSlice.actions;

export default orgSlice.reducer;
